// extracted by mini-css-extract-plugin
module.exports = {"container":"Navbar_container__rxFeS","navbar":"Navbar_navbar__66x_3","logo":"Navbar_logo__E_Sw_","signupBtn":"Navbar_signupBtn__pl0VZ","loginBtn":"Navbar_loginBtn__cMi7S"};